import Client from '@/client'

export default {
  // list(query=undefined) {
  //   return Client.get(`holdbacks/`, { params: { query: `{id,uuid,name,completion{name},production{name},user{id,name},shape,status,version,updated_at}` } })
  // },
  // create(payload) {
  //   return Client.post(`holdbacks/`, payload)
  // },
  get_well_list(payload) {
    return Client.post(`holdback/wells/`, payload)
  },
  get_filters(id, payload) {
    return Client.post(`holdback/${id}/filters/`, payload)
  },
  get_coordinates(id, payload) {
    return Client.post(`holdback/${id}/coordinates/`, payload)
  },
  // get_frame_data(id, payload) {
  //   return Client.post(`holdback/${id}/dataframe/`, payload)
  // },
  get_individuals(payload) {
    return Client.post(`holdback/individuals/`, payload)
  },
  get_timeline(payload) {
    return Client.post(`holdback/timeline/`, payload)
  },
  get_aggregates(payload) {
    return Client.post(`holdback/aggregates/`, payload)
  },
  get_exports(payload) {
    return Client.post(`holdback/exports/`, payload)
  },
  // get_production(id, payload) {
  //   return Client.post(`holdback/${id}/get_production/`, payload)
  // },
  // get_type_curves(id, payload) {
  //   return Client.post(`holdback/${id}/get_type_curves/`, payload)
  // },
  // get_statistics(id, payload) {
  //   return Client.post(`holdback/${id}/get_statistics/`, payload)
  // },
  // get_ratios(id, payload) {
  //   return Client.post(`holdback/${id}/get_ratios/`, payload)
  // },
  // get_decline(id, payload) {
  //   return Client.post(`holdback/${id}/get_decline/`, payload)
  // },
  // get_terminal_declines(id, payload) {
  //   return Client.post(`holdback/${id}/get_terminal_declines/`, payload)
  // },
  // get_downloads(id, payload) {
  //   return Client.post(`holdback/${id}/get_downloads/`, payload)
  // },
  // get_well_data(id, payload) {
  //   return Client.post(`holdback/${id}/get_well_data/`, payload)
  // },
  // set_well_params(id, payload) {
  //   return Client.post(`holdback/${id}/set_well_params/`, payload)
  // },
}